// extracted by mini-css-extract-plugin
module.exports = {"loader":"SlashesLoader_loader__3OKXV","pulse":"SlashesLoader_pulse__26p9K"};